<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label>Url Origem</label>

        <label class="fakeinput form-control">
          <span>{{url}}/</span>
          <input v-model="redirect.from" type="text" required maxlength="255" />
        </label>

        <small v-if="hintUrlFrom" class="text-danger">{{ hintUrlFrom }}</small>
      </div>

      <div class="form-group">
        <label>Url Destino</label>
        <input
          v-model="redirect.to"
          type="text"
          class="form-control"
          required
          maxlength="255"
        />
      </div>

      <div>
        <button type="submit" :disabled="submitDisabled" class="btn btn-primary">
          Salvar
        </button>
        <span class="btn btn-light" @click="goBack">Cancelar</span>
        <span v-if="id" class="btn btn-danger" @click="trash">Deletar</span>
      </div>
    </form>
  </div>
</template>

<style>
.fakeinput {
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
}
.fakeinput:focus-within {
  box-shadow: 0 0 0 0.1rem rgb(0 123 255 / 25%);
}

.fakeinput span {
  color: #999;
  font-weight: normal;
	white-space: nowrap;
}
.fakeinput input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: none;
  outline: none;
}
</style>

<script>
import axios from "axios";

export default {
  props: ["id"],
  data() {
    return {
      redirect: {
        from: "",
        to: "",
      },
    };
  },
  computed: {
	submitDisabled(){
	  var url = this.redirect.from.trim();
      if (!url) return true;
      if (url.match(/\s/)) return true
      var match = url.match(/([^a-z0-9._/*-])/i);
      if (match) return true
	  return false;
	},
    hintUrlFrom() {
      var url = this.redirect.from.trim();
      if (url.match(/\s/)) return `A url não pode ter espaços.`;
      var match = url.match(/([^a-z0-9._/*-])/i);
      if (match) return `A url contém o carectere "${match[1]}" inválido.`;
	  if(url==='*') return `Atenção: * fará com que todo o site seja redirecionado.`;
      return null;
    },
    project() {
      return this.$store.getters.project;
    },
		url(){
			if(this.project.domain) return this.project.domain;
			return `${this.project.slug}.${process.env.VUE_APP_BASEURL}`;
		}
  },


  methods: {

    goBack() {
      this.$router.go(-1);
      this.$router.push({ name: "redirects" });
    },

    onSubmit() {
      let project_id = this.project.id;

      let data = {
        project_id,
        ...this.redirect,
      };

      if (data.from == data.to) {
        return toastr(
          "URL destino deve ser diferente da url de origem",
          "Erro",
          "is-danger"
        );
      }

      axios({
        method: "post",
        url: "/api/redirects" + (data.id ? `/${data.id}` : ""),
        data: data,
      })
        .then((res) => {
          this.$router.push({ name: "redirects" });
        })
        .catch((err) => {
          toastr(err.response.data, "Erro", "is-danger");
        });
    },
    trash() {
      if (!confirm("Tem certeza?")) return;
      axios({
        method: "delete",
        url: "/api/redirects/" + this.redirect.id,
      }).then((res) => {
        this.$router.push({ name: "redirects" });
      });
    },
  },
  mounted() {
    if (this.id) {
      axios({
        url: "/api/redirects/" + this.id,
      }).then((res) => {
        this.redirect = res.data;
      });
    }
  },
};
</script>
